import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-duration-crohn',
    templateUrl: './bar-chart-stable-unstable-duration-crohn.component.html',
    styleUrls: ['./bar-chart-stable-unstable-duration-crohn.component.css']
})

export class BarChartStableUnstableDurationCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  // 10, 20, 30, 40
  remissione = [];
  attivitaLieve = [];
  attivitaModerata = [];
  attivitaGrave = [];
  // other arrays
  stabiliLieve10 = 0;
  stabiliModerata10 = 0;
  stabiliGrave10 = 0;
  stabiliRemissione10 = 0;
  instabiliMiglLieve10 = 0;
  instabiliMiglModerata10 = 0;
  instabiliMiglGrave10 = 0;
  instabiliPegLieve10 = 0;
  instabiliPegModerata10 = 0;
  instabiliPegGrave10 = 0;
  instabiliMiglRemissione10 = 0;
  instabiliPegRemissione10 = 0;
  
  stabiliLieve20 = 0;
  stabiliModerata20 = 0;
  stabiliGrave20 = 0;
  stabiliRemissione20 = 0;
  instabiliMiglLieve20 = 0;
  instabiliMiglModerata20 = 0;
  instabiliMiglGrave20 = 0;
  instabiliPegLieve20 = 0;
  instabiliPegModerata20 = 0;
  instabiliPegGrave20 = 0;
  instabiliMiglRemissione20 = 0;
  instabiliPegRemissione20 = 0;
  
  stabiliLieve30 = 0;
  stabiliModerata30 = 0;
  stabiliGrave30 = 0;
  stabiliRemissione30 = 0;
  instabiliMiglLieve30 = 0;
  instabiliMiglModerata30 = 0;
  instabiliMiglGrave30 = 0;
  instabiliPegLieve30 = 0;
  instabiliPegModerata30 = 0;
  instabiliPegGrave30 = 0;
  instabiliMiglRemissione30 = 0;
  instabiliPegRemissione30 = 0;
  
  stabiliLieve40 = 0;
  stabiliModerata40 = 0;
  stabiliGrave40 = 0;
  stabiliRemissione40 = 0;
  instabiliMiglLieve40 = 0;
  instabiliMiglModerata40 = 0;
  instabiliMiglGrave40 = 0;
  instabiliPegLieve40 = 0;
  instabiliPegModerata40 = 0;
  instabiliPegGrave40 = 0;
  instabiliMiglRemissione40 = 0;
  instabiliPegRemissione40 = 0;

  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableCrohnDuration: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['0-10 ANNI-STABILI','0-10 ANNI-IN MIGLIORAMENTO','0-10 ANNI-IN PEGGIORAMENTO',
  '10-20 ANNI-STABILI','10-20 ANNI-IN MIGLIORAMENTO','10-20 ANNI-IN PEGGIORAMENTO',
  '20-30 ANNI-STABILI','20-30 ANNI-IN MIGLIORAMENTO','20-30 ANNI-IN PEGGIORAMENTO',
  '30+ ANNI-STABILI','30+ ANNI-IN MIGLIORAMENTO','30+ ANNI-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.attivitaLieve,
      barThickness: 10,
      backgroundColor: ['#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491',
       '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491'],
      hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800',
       '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800'],
      label: 'ATTIVITA LIEVE',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
        data: this.attivitaModerata,
        barThickness: 10,
        backgroundColor: ['#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', 
        '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769'],
        hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', 
        '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a'],
        label: 'ATTIVITA MODERATA',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
      {
        data: this.attivitaGrave,
        barThickness: 10,
        backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', 
        '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
        hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', 
        '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
        label: 'ATTIVITA GRAVE',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
    {
      data: this.remissione,
      barThickness: 10,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', 
      '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', 
      '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveDurationStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveDurationStableAndUnstable(){
    this.subscription = this.doctorService.getCrohnStableAndUnstableDuration().subscribe( data => {
      let keys = Object.keys(data);
      //console.log("Keys: " + keys);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissione10'){
            this.stabiliRemissione10 = values[i];
          }
          else if (key === 'StabiliLieve10'){
            this.stabiliLieve10 = values[i];
          }
          else if (key === 'StabiliModerata10'){
            this.stabiliModerata10 = values[i];
          }
          else if (key === 'StabiliGrave10'){
            this.stabiliGrave10 = values[i];
          }
          else if (key === 'InstabiliMiglLieve10'){
            this.instabiliMiglLieve10 = values[i];
          }
          else if (key === 'InstabiliMiglModerata10'){
            this.instabiliMiglModerata10 = values[i];
          }
          else if (key === 'InstabiliMiglGrave10'){
            this.instabiliMiglGrave10 = values[i];
          }
          else if (key === 'InstabiliLieve10'){
            this.instabiliPegLieve10 = values[i];
          }
          else if (key === 'InstabiliPegModerata10'){
            this.instabiliPegModerata10 = values[i];
          }
          else if (key === 'InstabiliPegGrave10'){
            this.instabiliPegGrave10 = values[i];
          }
          else if (key === 'InstabiliMiglRemissione10'){
            this.instabiliMiglRemissione10 = values[i];
          }
          else if (key === 'InstabiliPegRemissione10'){
            this.instabiliPegRemissione10 = values[i];
          }
          else if (key === 'StabiliRemissione20'){
            this.stabiliRemissione20 = values[i];
          }
          else if (key === 'StabiliLieve20'){
            this.stabiliLieve20 = values[i];
          }
          else if (key === 'StabiliModerata20'){
            this.stabiliModerata20 = values[i];
          }
          else if (key === 'StabiliGrave20'){
            this.stabiliGrave20 = values[i];
          }
          else if (key === 'InstabiliMiglLieve20'){
            this.instabiliMiglLieve20 = values[i];
          }
          else if (key === 'InstabiliMiglModerata20'){
            this.instabiliMiglModerata20 = values[i];
          }
          else if (key === 'InstabiliMiglGrave20'){
            this.instabiliMiglGrave20 = values[i];
          }
          else if (key === 'InstabiliPegLieve20'){
            this.instabiliPegLieve20 = values[i];
          }
          else if (key === 'InstabiliPegModerata20'){
            this.instabiliPegModerata20 = values[i];
          }
          else if (key === 'InstabiliPegGrave20'){
            this.instabiliPegGrave20 = values[i];
          }
          else if (key === 'InstabiliMiglRemissione20'){
            this.instabiliMiglRemissione20 = values[i];
          }
          else if (key === 'InstabiliPegRemissione20'){
            this.instabiliPegRemissione20 = values[i];
          }
          else if (key === 'StabiliRemissione30'){
            this.stabiliRemissione30 = values[i];
          }
          else if (key === 'StabiliLieve30'){
            this.stabiliLieve30 = values[i];
          }
          else if (key === 'StabiliModerata30'){
            this.stabiliModerata30 = values[i];
          }
          else if (key === 'StabiliGrave30'){
            this.stabiliGrave30 = values[i];
          }
          else if (key === 'InstabiliMiglLieve30'){
            this.instabiliMiglLieve30 = values[i];
          }
          else if (key === 'InstabiliMiglModerata30'){
            this.instabiliMiglModerata30 = values[i];
          }
          else if (key === 'InstabiliMiglGrave30'){
            this.instabiliMiglGrave30 = values[i];
          }
          else if (key === 'InstabiliPegLieve30'){
            this.instabiliPegLieve30 = values[i];
          }
          else if (key === 'InstabiliPegModerata30'){
            this.instabiliPegModerata30 = values[i];
          }
          else if (key === 'InstabiliPegGrave30'){
            this.instabiliPegGrave30 = values[i];
          }
          else if (key === 'InstabiliMiglRemissione30'){
            this.instabiliMiglRemissione30 = values[i];
          }
          else if (key === 'InstabiliPegRemissione30'){
            this.instabiliPegRemissione30 = values[i];
          }
          else if (key === 'StabiliRemissione40'){
            this.stabiliRemissione40 = values[i];
          }
          else if (key === 'StabiliLieve40'){
            this.stabiliLieve40 = values[i];
          }
          else if (key === 'StabiliModerata40'){
            this.stabiliModerata40 = values[i];
          }
          else if (key === 'StabiliGrave40'){
            this.stabiliGrave40 = values[i];
          }
          else if (key === 'InstabiliMiglLieve40'){
            this.instabiliMiglLieve40 = values[i];
          }
          else if (key === 'InstabiliMiglModerata40'){
            this.instabiliMiglModerata40 = values[i];
          }
          else if (key === 'InstabiliMiglGrave40'){
            this.instabiliMiglGrave40 = values[i];
          }
          else if (key === 'InstabiliPegLieve40'){
            this.instabiliPegLieve40 = values[i];
          }
          else if (key === 'InstabiliPegModerata40'){
            this.instabiliPegModerata40 = values[i];
          }
          else if (key === 'InstabiliPegGrave40'){
            this.instabiliPegGrave40 = values[i];
          }
          else if (key === 'InstabiliMiglRemissione40'){
            this.instabiliMiglRemissione40 = values[i];
          }
          else if (key === 'InstabiliPegRemissione40'){
            this.instabiliPegRemissione40 = values[i];
          }
      }
      
      // riempio il vettore della categoria 'grave' in ordine stabili, miglioramento e peggioramento
      this.attivitaGrave.push(this.stabiliGrave10);
      this.attivitaGrave.push(this.instabiliMiglGrave10);
      this.attivitaGrave.push(this.instabiliPegGrave10);
      this.attivitaGrave.push(this.stabiliGrave20);
      this.attivitaGrave.push(this.instabiliMiglGrave20);
      this.attivitaGrave.push(this.instabiliPegGrave20);
      this.attivitaGrave.push(this.stabiliGrave30);
      this.attivitaGrave.push(this.instabiliMiglGrave30);
      this.attivitaGrave.push(this.instabiliPegGrave30);
      this.attivitaGrave.push(this.stabiliGrave40);
      this.attivitaGrave.push(this.instabiliMiglGrave40);
      this.attivitaGrave.push(this.instabiliPegGrave40);
      // riempio il vettore della categoria 'lieve' in ordine stabili, miglioramento e peggioramento
      this.attivitaLieve.push(this.stabiliLieve10);
      this.attivitaLieve.push(this.instabiliMiglLieve10);
      this.attivitaLieve.push(this.instabiliPegLieve10);
      this.attivitaLieve.push(this.stabiliLieve20);
      this.attivitaLieve.push(this.instabiliMiglLieve20);
      this.attivitaLieve.push(this.instabiliPegLieve20);
      this.attivitaLieve.push(this.stabiliLieve30);
      this.attivitaLieve.push(this.instabiliMiglLieve30);
      this.attivitaLieve.push(this.instabiliPegLieve30);
      this.attivitaLieve.push(this.stabiliLieve40);
      this.attivitaLieve.push(this.instabiliMiglLieve40);
      this.attivitaLieve.push(this.instabiliPegLieve40);
      // riempio il vettore della categoria 'moderata' in ordine stabili, miglioramento e peggioramento
      this.attivitaModerata.push(this.stabiliModerata10);
      this.attivitaModerata.push(this.instabiliMiglModerata10);
      this.attivitaModerata.push(this.instabiliPegModerata10);
      this.attivitaModerata.push(this.stabiliModerata20);
      this.attivitaModerata.push(this.instabiliMiglModerata20);
      this.attivitaModerata.push(this.instabiliPegModerata20);
      this.attivitaModerata.push(this.stabiliModerata30);
      this.attivitaModerata.push(this.instabiliMiglModerata30);
      this.attivitaModerata.push(this.instabiliPegModerata30);
      this.attivitaModerata.push(this.stabiliModerata40);
      this.attivitaModerata.push(this.instabiliMiglModerata40);
      this.attivitaModerata.push(this.instabiliPegModerata40);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissione10);
      this.remissione.push(this.instabiliMiglRemissione10);
      this.remissione.push(this.instabiliPegRemissione10);
      this.remissione.push(this.stabiliRemissione20);
      this.remissione.push(this.instabiliMiglRemissione20);
      this.remissione.push(this.instabiliPegRemissione20);
      this.remissione.push(this.stabiliRemissione30);
      this.remissione.push(this.instabiliMiglRemissione30);
      this.remissione.push(this.instabiliPegRemissione30);
      this.remissione.push(this.stabiliRemissione40);
      this.remissione.push(this.instabiliMiglRemissione40);
      this.remissione.push(this.instabiliPegRemissione40);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableCrohnDuration') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableCrohnDuration = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableCrohnDuration.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableCrohnDuration.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' || 
              this.myChartStableUnstableCrohnDuration.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
              this.myChartStableUnstableCrohnDuration.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
              this.myChartStableUnstableCrohnDuration.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'ATTIVITA MODERATA'
            || legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}